<template>
    <div class="card">
        <Toast />
        <form>
            <div class="p-grid p-fluid">
                <div class="p-col-12">
                    <h5><b>{{ $t('Admin.EditAdmin.Header') }}</b></h5>

                    <div class="p-grid p-formgrid p-mb-3">
                        <div class="p-col-12 p-mb-2 p-lg-6 p-mb-lg-0 p-field">
                            <label for="title2"><b>{{ $t('Admin.EditAdmin.Name') }}</b></label>
                            <InputText :class="`${error.name ? 'p-invalid' : ''}`" type="text"
                                :placeholder="$t('Admin.EditAdmin.PlaceName')" id="title2" v-model="name" @keydown.space="preventLeadingSpace"></InputText>
                            <div class="text-red">{{ error.name }}</div>
                        </div>
                    </div>

                    <div class="p-grid p-formgrid p-mb-3">
                        <div class="p-col-12 p-mb-2 p-lg-6 p-mb-lg-0 p-field">
                            <label for="title2"><b>{{ $t('Admin.EditAdmin.Email') }}</b></label>
                            <InputText :class="`${error.email ? 'p-invalid' : ''}`" type="text"
                                :placeholder="$t('Admin.EditAdmin.PlaceEmail')" id="disss" v-model="email" @keydown.space="preventLeadingSpace" disabled></InputText>
                            <div class="text-red">{{ error.email }}</div>
                        </div>
                    </div>
                    <div class="p-grid p-formgrid p-mb-3">
                        <div class="p-col-12 p-mb-2 p-lg-6 p-mb-lg-0 p-field">
                            <label for="title2"><b>{{ $t('Admin.EditAdmin.Phone') }}</b></label>
                            <InputText :class="`${error.phone ? 'p-invalid' : ''}`" type="text"
                                :placeholder="$t('Admin.EditAdmin.PlacePhone')" id="title2" v-model="phone_number"
                                onkeypress="return /[0-9]/i.test(event.key)" maxlength="11" @keydown.space="preventLeadingSpace"></InputText>
                            <div class="text-red">{{ error.phone }}</div>
                        </div>
                    </div>
                    <div class="p-grid p-formgrid p-mb-3">
                        <div class="p-col-12 p-mb-2 p-lg-6 p-mb-lg-0 p-field">
                            <label for="top_10"><b>{{ $t('Admin.EditAdmin.Menuauthorization') }}</b></label>
                            <br />
                            <!-- <Dropdown v-model="dropdownValue" modelValue="dropdownValues[0].name" :options="dropdownValues" optionLabel="code" :placeholder="status" /> -->
                            <div :class="`${error.menus ? 'p-invalid' : ''}`" id="accesscheck">
                                <div v-for="item in menu" :key="item.id">
                                    <!-- <p>{{ item.status }}</p> -->
                                    <input @click="GetMenu($event)" type="checkbox" :value="item.menu_id"
                                        v-model="menus" />
                                    <label>{{ $t(item.menu_name) }}</label>
                                </div>
                                <!-- <div>
                                    <input type="checkbox" id="MM" name="MM" value="3" v-model="menus" />
                                    <label for="3">{{ $t('Admin.EditAdmin.Menu2') }}</label>
                                </div>
                                <div>
                                    <input type="checkbox" id="PM" value="4" name="PM" v-model="menus" />
                                    <label for="4">{{ $t('Admin.EditAdmin.Menu3') }}</label>
                                </div>
                                <div>
                                    <input type="checkbox" id="PPM" name="PPM" value="5" v-model="menus" />
                                    <label for="5">{{ $t('Admin.EditAdmin.Menu4') }}</label>
                                </div>
                                <div>
                                    <input type="checkbox" id="BBM" value="6" name="BBM" v-model="menus" />
                                    <label for="6">{{ $t('Admin.EditAdmin.Menu5') }}</label>
                                </div>
                                <div>
                                    <input type="checkbox" id="Info" name="Info" value="7" v-model="menus" />
                                    <label for="7">{{ $t('Admin.EditAdmin.Menu6') }}</label>
                                </div>
                                <div>
                                    <input type="checkbox" id="LC" value="8" name="LC" v-model="menus" />
                                    <label for="8">{{ $t('Admin.EditAdmin.Menu7') }}</label>
                                </div> -->
                            </div>
                            <div class="text-red">{{ error.menus }}</div>
                        </div>
                    </div>
                </div>
            </div>
            <br>
            <div class="p-d-flex p-jc-end p-ai-center" style="float: left">
                <Button :label="$t('Admin.EditAdmin.Save')" icon="pi pi-check" iconPos="left"
                    class="p-button p-button p-mr-2 p-mb-2" @click="UpdateAdmin" style="margin-top: -30px; background: black; color: white;" id="Save"></Button>
            </div>
            <div class="p-d-flex p-jc-end p-ai-center" style="float: right;">
                <Button :label="$t('Admin.EditAdmin.Back')" icon="pi pi-replay" iconPos="left"
                    class="p-button p-button-outlined p-button p-mr-2 p-mb-2" @click="$router.go(-1)"
                    style="margin-top: -30px; background: white; color: black;"></Button>
            </div>
            <div class="p-d-flex p-jc-end p-ai-center">
                <div></div>
            </div>
        </form>
    </div>
</template>

<script>
import axios from 'axios';
import { useRoute } from 'vue-router';
import AdminService from '../../service/API/AdminService';
// import validateCreateFaq from '../../validations/faq/validateCreateFaq';
import validateEditAdmin from '../../validations/AdminManagement/validateEditAdmin';
export default {
    name: 'AddBanner',
    // props: ['dog', 'image'],
    data() {
        return {
            render1: false,
            render2: false,
            dropdownValues: [
                { name: 'active', code: '활성' },
                { name: 'inactive', code: '비활성' },
            ],
            // dropdownValueTypes: [{ name: 'nft',code:'NFT' }, { name: 'card_news',code:'Card News' }, { name: 'media_press',code:'Media press' }, { name: 'de_fi_services',code:'De-Fi Services' }],
            dropdownValue: '',
            // dropdownValueType: null,
            id: '',
            name: '',
            email: '',
            phone_number: '',
            menus: [],
            // menu:localStorage.getItem('menu'),
            menu: [],
            formData: new FormData(),
            error: {},
        };
    },
    created() {
        this.adminService = new AdminService();
    },
    mounted() {
        const route = useRoute();
        console.log(route.params);
        this.loading1 = true;
        // this.faqService.getFaqCategoryDropdown().then((data) => {
        //     this.categoryDropdownValues = data;
        //     //this.products = data;
        //     this.loading1 = false;
        //     // this.products.forEach((customer) => (customer.createdDate = new Date(customer.createdDate)));
        //     console.log(this.products);
        //     console.log(data);
        // });
        this.adminService.viewAdmin(this.$route.params.id).then((res) => {
            this.name = res.name;
            this.email = res.email;
            this.phone_number = res.phone_number;
            this.menu = res.menu;
            this.menus = this.menu.map((m) => {
                if (m.status === 'active') {
                    return m.menu_id;
                }
            }).filter((f) => f != undefined)
            // localStorage.setItem('menu',JSON.stringify(res.menu));
            // console.log(res);
            // console.log(res.menu);
            // console.log(this.menus);
            // console.log(this.menu[0].status)
        });
    },
    methods: {
        reinitialize() {
            (this.email = null), (this.name = null), (this.phone_number = null), (this.menus = null);
        },
        open() {
            this.display = true;
        },
        close() {
            this.display = false;
        },
        GetMenu(e) {
            // console.log(data)
            if (e.target.checked) {
                // console.log(e.target.value)
            }

        },
        preventLeadingSpace(e) {
            // only prevent the keypress if the value is blank
            if (!e.target.value) e.preventDefault();
            // otherwise, if the leading character is a space, remove all leading white-space
            else if (e.target.value[0] == ' ') e.target.value = e.target.value.replace(/^\s*/, "");
        },

        UpdateAdmin() {
            let vcheckData = {
                //     category_id: this.category_id.toString(),
                name: this.name,
                email: this.email,
                phone: this.phone_number,
                // menus: this.menus.toString(),
                //     top_10: this.top_10,
                //     state: this.status,
                //     // type: this.dropdownValueType == null ? '' : 'something',
            };
            const { isInvalid, error } = validateEditAdmin(vcheckData);
            if (isInvalid) {
                this.error = error;
                console.log(error);
            } else {
                this.error = '';
            // console.log(this.formData);
            return axios
                .post('api/v1/admin/user/admin-update', { id: this.$route.params.id, name: this.name, email: this.email, phone: this.phone_number, menus: this.menus.toString() })
                .then(() => {
                    // alert('성공적으로 저장');
                    // this.$toast.add({ severity: 'info', summary: 'Confirmed', detail: 'Succesfully Published.', life: 3000 });
                    this.$router.push({ name: 'Admin Management' });
                    setTimeout(() => {
                        this.$toast.add({ severity: 'success', summary: '삭제', detail: '어드민이 업데이트 되었습니다. .', life: 3000 });
                    }, 500);
                });
        }
        },
    },
};
</script>

<style scoped>
.img-info {
    font-size: 11px;
    font-weight: 400;
    color: rgb(48, 48, 48);
}

.custom-select {
    position: relative;
    border: 1px solid #cecece;
    border-radius: 8px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-left: 15px;
}

.custom-select-invalid {
    position: relative;
    border: 1px solid red;
    border-radius: 8px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-left: 15px;
}

.select-file {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0%;
    z-index: 5;
    opacity: 0;
}

.SelectBtn {
    max-width: 100px;
}

.custom-select span {
    max-width: 140px;
    display: inline-block;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

.p-button {
    background: #000000;
    border: 1px solid #0a0a0a;
    color: white;
}

div#accesscheck {
    margin-top: 10px;
    line-height: 30px;
}
input#disss {
    background: darkgray;
    color: black;
}
</style>
